export default __webpack_public_path__ + "2bddc3f78df8a472f01e79e5cda845f6.png";